@if(wizardStore.B().form; as formGroup){
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-number-input
      [label]="'general.collectionTargetAmount'"
      inputFormControlName="collectionTargetAmount"
      [inputFormControl]="formGroup.controls.collectionTargetAmount"
    />
    <app-validated-number-input
      [label]="translationKey + 'existingCollections'"
      inputFormControlName="existingCollections"
      [inputFormControl]="formGroup.controls.existingCollections"
    />
    <hr />
    <app-validated-date-picker
      [label]="translationKey + 'collectionEndDate'"
      inputFormControlName="collectionEndDate"
      [inputFormControl]="formGroup.controls.collectionEndDate"
    />
    <app-validated-dropdown
      [label]="translationKey + 'notCompletedCollectionCase'"
      inputFormControlName="notCompletedCollectionCase"
      [inputFormControl]="formGroup.controls.notCompletedCollectionCase"
      [loading]="!genericStore.allLoaded()"
      [optionsStamp]="genericStore.incompleteCollectionCaseEntities().length"
    >
      @for (option of genericStore.incompleteCollectionCaseEntities(); track
      option.id) {
      <option [value]="option.id">
        {{ option.description }}
      </option>
      }
    </app-validated-dropdown>

    <app-card [titleKey]="translationKey + 'offerAmount'">
      <div class="row flex-between-center">
        <div class="col-6 my-2">
          <app-validated-number-input
            [label]="'general.minimum'"
            inputFormControlName="minimumOfferAmount"
            [inputFormControl]="formGroup.controls.minimumOfferAmount"
          />
        </div>
        <div class="col-6 my-2">
          <app-validated-number-input
            [label]="'general.maximum'"
            inputFormControlName="maximumOfferAmount"
            [inputFormControl]="formGroup.controls.maximumOfferAmount"
          />
        </div>
      </div>
    </app-card>

    <app-validated-number-input
      [label]="translationKey + 'poFunds'"
      inputFormControlName="poFunds"
      [placeholder]="translationKey + 'poFundsPlaceholder'"
      [inputFormControl]="formGroup.controls.poFunds"
    />

    <app-validated-number-input
      [label]="translationKey + 'communityFunds'"
      inputFormControlName="communityFunds"
      [inputFormControl]="formGroup.controls.communityFunds"
    />
    <hr />
    <app-info-label [label]="translationKey + 'formInfo'" />
  </app-card>
</form>

}
